import ComponentProperties from "../Properties";
import Events from "../Events";
import Styles from "../Styles";
import React from "react";

const TabContent = ({availableTabs, activeTab}) => {
    return (
        <div style={{marginTop: 10}}>
            {availableTabs.map((tab, index) => {
                if (activeTab === index) {
                    switch (tab) {
                        case 'properties':
                            return <div key={index}><ComponentProperties/></div>;
                        case 'events':
                            return <div key={index}><Events/></div>;
                        case 'styles':
                            return <div key={index}><Styles/></div>;
                        default:
                            return <div key={index}>default return</div>
                    }
                }
                return null
            })}
        </div>
    )
};
export default TabContent